import { GeneratedTemplateType } from '../types/util-types';

export const TRANSLATION_COMPONENTS = {
    sup: <sup />,
    small: <small />,
    p: <p />,
    ul: <ul />,
    li: <li />,
    ol: <ol />,
    strong: <strong />,
    span: <span />,
    a: <a />,
    em: <em />,
    br: <br />
};

export const CLICK_START_TRIAL_ADDITIONAL_DATA_STORAGE_KEY = 'additionalData';
export const CURRENT_REFERER_STORAGE_KEY = 'currentReferrer';
export const DEVICE_FINGERPRINT_SESSION_KEY = 'device-fingerprint-session-key';

const EXCLUSION_PATHS = [
    '/',
    '/about',
    '/press',
    '/contact-us',
    '/referrals',
    '/404',
    '/careers',
    '/invites',
    '/careers',
    '/educators',
    '/product-education',
    '/activation',
    '/unsupported',
    '/terms/terms-of-service',
    '/terms/terms-of-service-original',
    '/terms/privacy',
    '/terms/privacy-original',
    '/feedback',
    '/getstarted-honeybook',
    '/client-relationships'
];

export const PROMO_POPUP_EXCLUSION_PATHS = [
    ...EXCLUSION_PATHS,
    '/',
    '/getstarted'
];

export const PROMO_BANNER_EXCLUSION_PATHS = [...EXCLUSION_PATHS];

export const VARIANT_OPTIONS = ['a', 'b', 'c', 'd', 'e', 'f'];

export const INITIAL_DOLLAR_AMOUNT = 14123;

export const CAPTERRA_REVIEWS = {
    rating: 4.8,
    totalReviews: 598,
    bestRating: '5',
    worstRating: '1',
    url: 'https://www.capterra.com/p/162588/HoneyBook/',
    iconUrl: 'marketing_site/pricing/ratings/Capterra_logo_2x.png'
};
export const G2_REVIEWS = {
    rating: 4.5,
    totalReviews: 158,
    bestRating: '5',
    worstRating: '1',
    url: 'https://www.g2.com/products/honeybook/reviews',
    iconUrl: 'marketing_site/pricing/ratings/g2-color.png'
};
export const APPLE_REVIEWS = {
    rating: 4.8,
    totalReviews: 13900,
    bestRating: '5',
    worstRating: '1',
    url: 'https://apps.apple.com/us/app/honeybook-small-business-crm/id1104772757',
    iconUrl: 'marketing_site/pricing/ratings/appleAppStore.png'
};

export const INITIAL_EMAIL_SIGNATURE_DISPLAY_VALUE = {
    imageUrl:
        'https://res.cloudinary.com/honeybook/image/upload/v1693999725/marketing_site/email-signature/signature-image-empty-state.png',
    name: 'Gunther Anders',
    jobTitle: 'Founder',
    company: "Gunther's Barista Academy",
    email: 'gunther@gunthersbaristas.com',
    address: '199 Lafayette St, New York, NY 10012, USA',
    phone: '210-559-2358',
    website: 'https://www.gunthersbaristas.com',
    facebookUrl: '_',
    twitterUrl: '_',
    linkedinUrl: '_',
    instagramUrl: '_',
    pinterestUrl: '_',
    youtubeUrl: '_',
    selectedTemplateName: 'conservative'
};

export const REFERRAL_DISCOUNT_KEY = 'referralDiscount';

export const TEMPLATE_SELECTION_STORAGE_KEY = 'hb_template_selection';

export const PERSONALIZED_TEMPLATE_STORAGE_KEY = 'hb_personalized_template';

export interface TemplateItem {
    label: string;
    value: string;
}

export interface CompanyTypeTemplate {
    label: string;
    value: string;
    templateTypes: {
        [key in GeneratedTemplateType]?: TemplateItem[];
    };
}

export const COMPANY_TYPE_TEMPLATES: CompanyTypeTemplate[] = [
    {
        label: 'baker',
        value: 'cake',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Catering Contract',
                    value: 'catering_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Agreement Amendment',
                    value: 'agreement_amendment'
                }
            ]
        }
    },
    {
        label: 'blogger',
        value: 'blogger',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Brand Ambassador Contract',
                    value: 'brand_ambassador_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'bookkeeper / accountant',
        value: 'accounting',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'business consultant',
        value: 'business_consultant',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Non-Disclosure Agreement',
                    value: 'non_disclosure_agreement'
                }
            ]
        }
    },
    {
        label: 'caterer',
        value: 'caterer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Catering Contract',
                    value: 'catering_contract'
                },
                {
                    label: 'Event Planning Contract',
                    value: 'event_planning_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'cleaner',
        value: 'cleaning',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Home Services Contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'coach',
        value: 'coaching',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Coaching Contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'content creator',
        value: 'content_creation',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Brand Ambassador Contract',
                    value: 'brand_ambassador_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'general contractor',
        value: 'contractor',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Residential Interior Design Services Contract',
                    value: 'residential_interior_design_services_contract'
                },
                {
                    label: 'Home Services Contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'digital marketer',
        value: 'digital_marketing',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Social Media Services Contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                }
            ]
        }
    },
    {
        label: 'DJ / musician',
        value: 'dj_musician',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'DJ Contract',
                    value: 'dj_contract'
                },
                {
                    label: 'Equipment Rental Contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'doula',
        value: 'doula',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Coaching Contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'Waiver of Liability Agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'tutor/educator',
        value: 'education',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Coaching Contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'event planner',
        value: 'event_planning',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Event Planning Contract',
                    value: 'event_planning_contract'
                },
                {
                    label: 'Equipment Rental Contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'fashion stylist',
        value: 'fashion',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Brand Ambassador Contract',
                    value: 'brand_ambassador_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Design Approval',
                    value: 'design_approval'
                }
            ]
        }
    },
    {
        label: 'florist',
        value: 'florist',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Equipment Rental Contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'Event Planning Contract',
                    value: 'event_planning_contract'
                }
            ]
        }
    },
    {
        label: 'graphic designer',
        value: 'graphic_designer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Design Approval',
                    value: 'design_approval'
                },
                {
                    label: 'Social Media Services Contract',
                    value: 'social_media_services_contract'
                }
            ]
        }
    },
    {
        label: 'hairdresser / makeup artist',
        value: 'hair_makeup',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Makeup Artist Contract',
                    value: 'makeup_artist_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Waiver of Liability Agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'health & wellness coach',
        value: 'wellness',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Coaching Contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'interior designer',
        value: 'interior_designer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Residential Design Contract',
                    value: 'residential_design_contract'
                },
                {
                    label: 'Home Services Contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'landscaper',
        value: 'landscape',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Landscaping Contract',
                    value: 'landscaping_contract'
                },
                {
                    label: 'Home Services Contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'marketing agency',
        value: 'marketing_agency',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Social Media Services Contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'marketing consultant',
        value: 'marketing_consulting',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Social Media Services Contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'photographer',
        value: 'photographer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Photography Contract',
                    value: 'photography_contract'
                },
                {
                    label: 'Appearance Release Agreement',
                    value: 'appearance_release_agreement'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'event planner',
        value: 'event_planner',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Event Planner Contract',
                    value: 'event_planner_contract'
                },
                {
                    label: 'Equipment Rental Contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'realtor',
        value: 'real_estate',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                }
            ]
        }
    },
    {
        label: 'rental business owner',
        value: 'rental',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Equipment Rental Contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'Waiver of Liability Agreement',
                    value: 'waiver_of_liability_agreement'
                },
                {
                    label: 'Venue Rental Contract',
                    value: 'venue_rental_contract'
                }
            ]
        }
    },
    {
        label: 'social media manager',
        value: 'social_media',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Social Media Services Contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'Consulting Contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                }
            ]
        }
    },
    {
        label: 'venue owner',
        value: 'venue',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Venue Rental Contract',
                    value: 'venue_rental_contract'
                },
                {
                    label: 'Equipment Rental Contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'Waiver of Liability Agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'videographer',
        value: 'cinematography',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Videographer Contract',
                    value: 'videographer_contract'
                },
                {
                    label: 'Photography Contract',
                    value: 'photography_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'virtual assistant',
        value: 'virtual_assistant',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Retainer Contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Social Media Services Contract',
                    value: 'social_media_services_contract'
                }
            ]
        }
    },
    {
        label: 'visual artist',
        value: 'visual_artist',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Design Approval',
                    value: 'design_approval'
                },
                {
                    label: 'Agreement Amendment',
                    value: 'agreement_amendment'
                }
            ]
        }
    },
    {
        label: 'web designer',
        value: 'web_designer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Design Approval',
                    value: 'design_approval'
                },
                {
                    label: 'Non-Disclosure Agreement',
                    value: 'non_disclosure_agreement'
                }
            ]
        }
    },
    {
        label: 'other',
        value: 'other',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'Services Agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'Non-Disclosure Agreement',
                    value: 'non_disclosure_agreement'
                },
                {
                    label: 'Waiver of Liability Agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    }
];
